import { PaymentTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1130. 支払タスク請求金額編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/update_payment_amount
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  payment_amount: number;
  payment_amount_including_tax?: number;
  payment_amount_description?: string;
  withholding_tax_amount: number;
};

const updatePaymentAmount = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/update_payment_amount`,
    props
  );
};

export const useUpdatePaymentAmount = () => {
  return useMutation({
    mutationFn: updatePaymentAmount,
  });
};
